export default "__VITE_ASSET__4qegdVv1__"